<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-8 p-0">
          <h1 class="m-0">
            <a href="/admin/newsletter" class="btn btn-primary btn-lg" style="font-size: 15px; margin-right: 15px">Voltar</a>
            Editar campanha
          </h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-8">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/newsletter">Newsletter</a></li>
            <li class="breadcrumb-item">{{ campanha.id }}</li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid  -->
  </div>
  <!-- EDITAR-->
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label for="exampleInputFile">Nome de referência</label>
              <input class="form-control" v-model="formData.nome_campanha" />

              <span style="color: red" v-for="error in v$.nome_campanha.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label for="exampleInputFile">Título da campanha</label>
              <input class="form-control" v-model="formData.titulo_campanha" />

              <span style="color: red" v-for="error in v$.titulo_campanha.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label for="exampleInputFile">Link</label>
              <input class="form-control" v-model="formData.conteudo_link" />

              <span style="color: red" v-for="error in v$.conteudo_link.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label for="exampleInputFile">Imagem</label>
              <input class="form-control" type="file" @change="onChange" />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label>Pré-visualizar</label>
            </div>
          </div>

          <div class="col-sm-12" v-if="preview">
            <div class="form-group" v-if="!formData.upload_files">
              <img
                style="cursor: pointer; max-height: 235px; max-width: 325px"
                :src="getImagePath(campanha)"
                data-toggle="modal"
                data-target="#exibir-imagem-modal"
              />
            </div>

            <div class="form-group" v-else>
              <img
                style="cursor: pointer; max-height: 235px; max-width: 325px"
                :src="url_arquivo"
                data-toggle="modal"
                data-target="#exibir-imagem-modal"
              />
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label for="nome">Lista</label>
              <select disabled class="custom-select rounded-0" v-model="formData.lista_id" style="text-transform: uppercase">
                <option value=""></option>
                <option v-for="lista in newsletter_listas" :key="lista.id" :value="lista.id">{{ lista.nome }}</option>
              </select>
            </div>
          </div>

          <div class="p-2" style="width: 100%">
            <button type="submit" class="btn btn-primary" @click="update()">Salvar</button>
            <a id="close_editar" href="/admin/newsletter" data-dismiss="modal" @click="close" class="btn btn-danger" style="margin-left: 15px">
              Voltar
            </a>

            <a
              @click="email_teste = user.email"
              class="btn btn-primary"
              type="submit"
              data-toggle="modal"
              data-target="#enviar-teste-modal"
              style="margin-left: 15px"
            >
              Enviar teste
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ENVIAR TESTE -->
  <div class="modal fade" id="enviar-teste-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <div class="form-group">
              <label>E-mail</label>
              <input class="form-control" v-model="email_teste" />
            </div>

            <button @click="enviarTeste" type="submit" class="btn btn-success">Enviar teste</button>

            <button
              id="close_modal"
              style="margin-left: 15px"
              type="submit"
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#enviar-teste-modal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- EXIBIR IMAGEM MODAL -->
  <div class="modal fade" id="exibir-imagem-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <div class="form-group" v-if="!formData.upload_files">
              <img style="width: 100%" :src="getImagePath(campanha)" data-toggle="modal" data-target="#exibir-imagem-modal" />
            </div>

            <div class="form-group" v-else>
              <img style="width: 100%" :src="url_arquivo" data-toggle="modal" data-target="#exibir-imagem-modal" />
            </div>

            <button type="submit" class="btn btn-primary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import awsController from "../../controller/awsController.js";
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  props: ["campanha", "acaoRealizada", "closeModal", "user"],

  mixins: [sweetAlert, Swal, AuxController, awsController],

  components: { Loading, Editor, InputMask },

  data() {
    return {
      isLoading: false,
      registro_selecionado: "",
      filtro: "",
      paginas: [],
      registros: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome_contato: "",
      max_page: 0,
      editar_registro: false,
      cadastrar_registro: false,
      conteudo: "",
      preview: true,
      url_arquivo: "",
      newsletter_listas: [],
      email_teste: "",
    };
  },

  setup() {
    const formData = reactive({
      nome_campanha: "",
      titulo_campanha: "",
      data_agendamento: "",
      conteudo_link: "",
      upload_files: "",
      url_imagem: "",
    });

    const rules = computed(() => {
      let local_rules = {
        nome_campanha: { required },
        titulo_campanha: { required },
        data_agendamento: { required },
        conteudo_link: { required },
        upload_files: { required },
      };

      return local_rules;
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log(this.campanha);

    this.formData.nome_campanha = this.campanha.campanha_ref;
    this.formData.titulo_campanha = this.campanha.campanha_titulo;
    this.formData.data_agendamento = this.campanha.data_agendamento;
    this.formData.conteudo_link = this.campanha.link;
    this.formData.url_imagem = this.campanha.url_imagem;
    this.formData.lista_id = this.campanha.lista_id;

    this.buscarListas();
  },

  methods: {
    getImagePath(campanha) {
      if (campanha.url_imagem && campanha.url_imagem.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + campanha.url_imagem;
      } else if (campanha.url_imagem && campanha.url_imagem.includes("rochaleiloes")) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + campanha.url_imagem;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + campanha.url_imagem;
      }
    },

    enviarTeste() {
      this.isLoading = true;

      let data = {
        campanha_id: this.campanha.id,
        email: this.email_teste,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter/enviar_teste", data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessageWithButton("Sucesso!", response.data.msg);

            let btn = document.getElementById("close_modal");
            btn.click();
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    async update() {
      let url_imagem = null;

      this.isLoading = true;

      if (this.formData.upload_files) {
        console.log("UPLOAD");
        url_imagem = await this.sendFileS3("rochaleiloes2/newsletter/", this.formData.upload_files); // Corrigido: chamada correta da função

        console.log(url_imagem);
      } else {
        console.log("SEM UPLOAD");
        this.formData.upload_files;
      }

      let data = {
        campanha_id: this.campanha.id,
        link: this.formData.conteudo_link,
        campanha_ref: this.formData.nome_campanha,
        campanha_titulo: this.formData.titulo_campanha,
        lista_id: this.formData.lista_id,
      };

      if (url_imagem) {
        data.url_imagem = url_imagem;
      }

      console.log("Atualizando");
      console.log(data);

      axios
        .post("/admin/newsletter_campanhas/update", data)
        .then((response) => {
          this.isLoading = true;

          let btn = document.getElementById("close_editar");
          btn.click();

          this.showSuccessMessageWithButton("Sucesso", "Campanha editada");
          this.acaoRealizada("editar");
        })
        .catch((error) => {
          this.isLoading = true;

          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });

      // continue aqui com o uso de `data`
    },

    onChange(e) {
      this.formData.upload_files = e.target.files[0];
      this.url_arquivo = URL.createObjectURL(this.formData.upload_files);
    },

    buscarListas() {
      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter_listas/search", data)
        .then((response) => {
          this.newsletter_listas = response.data.newsletter_listas;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    onChange(e) {
      this.formData.upload_files = e.target.files[0];
      this.url_arquivo = URL.createObjectURL(this.formData.upload_files);
    },

    uploadFD(file) {
      this.isLoading = true;

      let fileName = file.split("/");

      let data = {
        link: this.formData.conteudo_link,
        campanha_ref: this.formData.nome_campanha,
        campanha_titulo: this.formData.titulo_campanha,
        data_agendamento: this.formatDateToSave(this.formData.data_agendamento),
        url_imagem: file,
      };

      console.log("Cadastrando");
      console.log(data);

      axios
        .post(`/admin/newsletter/store`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Campanha cadastrada", "/admin/newsletter");
        })
        .catch((error) => {
          console.log(error);

          this.isLoading = false;

          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDateToSave(date) {
      return moment(date, "DD/MM/yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss");
    },

    buscarRegistros() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      let url = null;

      if (this.objeto == "Lance") {
        url = "/admin/registros_deletados/lances/search";
      } else if (this.objeto == "Lote") {
        url = "/admin/registros_deletados/lotes/search";
      } else if (this.objeto == "Leilao") {
        url = "/admin/registros_deletados/leiloes/search";
      } else if (this.objeto == "Cadastro") {
        url = "/admin/registros_deletados/cadastros/search";
      }

      if (!url) {
        this.showErrorMessageWithButton("Ops...", "Selecione o tipo de objeto");
      } else {
        console.log("URL =");
        console.log(url);

        axios
          .post(url, data)
          .then((response) => {
            this.registros = response.data.registros;
            this.total = response.data.total;

            this.pagination(response.data);
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
    },

    limparFiltros() {
      this.objeto = null;
      this.registros = [];
    },

    deletar(registro) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: registro.id,
            };

            axios
              .post(`/admin/registro/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessage("registro deletado!");
                this.buscarRegistros();
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarRegistros();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.current-page {
  background-color: #428bca !important;
  color: white;
}

.modal-content {
  width: 1500px;
  margin-left: -430px;
}

@media screen and (max-width: 1600px) {
  .modal-content {
    width: 1350px;
    margin-left: -400px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1350px) {
  .modal-content {
    width: 1250px;
    margin-left: -350px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -280px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 1000px;
    margin-left: -240px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
    min-width: 400px;
  }
}
</style>
